import React, { useContext, useState } from 'react'
import { FlowBuilderContext, FlowBuilderContextPayload } from '../../../../../context/flowBuilderContext';
import { Grid, useMediaQuery } from '@mui/material';
import textStyles from "../../../../../assets/styles/componentStyles/manychatStyles/instagramStepComponent.module.scss"
import styles from '../../../../../assets/styles/componentStyles/manychatStyles/workflowFormComponents/workflowForm.module.scss'
import globalStyles from "../../../../../assets/styles/global.module.scss";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import GlobalPopUp from '../../../../utility/globalPopUp';
import CustomVarConditionPopup from './customConditions/customVarConditionPopup';
import { getCustomVariableConditionText } from '../../flowBuilderConstants';
import { useFlowBuilderStore } from '../../../../../store/flowBuilderStore';

const CustomVariableCondition = (props: any) => {

    const { actionData, stepAction } = props;
    const flagSmallScreen = useMediaQuery<boolean>('(min-width: 0px) and (max-width: 900px)');

    const [variableConditionPopup, setVariableConditionPopup] = useState<boolean>(false);

    const { nodes, setTempNodesTemplate } = useContext(FlowBuilderContext) as FlowBuilderContextPayload;
    const customVariableList = useFlowBuilderStore((state) => state.customVariableList)

    return (
        <>
            <Grid item>
                <Grid container direction={"column"} gap={"12px"}>
                    <Grid item mt={2} className={textStyles.templatesContainer}>
                        <Grid container direction={"column"} gap={"8px"} flexWrap={"nowrap"}>
                            <Grid item className={`${styles.bodyFormHeadingStyle} ${globalStyles.primaryFontSize} ${globalStyles.primaryFontWeight}`}>
                                Condition
                            </Grid>
                            <Grid item className={styles.contentBlockSubHeadingStyle} sx={{ '&:hover': { backgroundColor: "rgba(0,0,0,0.02)" }, padding: "2px 4px" }}>
                                <Grid container gap={1} justifyContent={"space-between"} flexWrap={"nowrap"} alignItems={"center"}>
                                    <Grid item sx={{ wordBreak: "break-word" }}>
                                        {actionData.chatbot_custom_variable_configuration_id ?
                                            <span>
                                                {getCustomVariableConditionText(customVariableList, actionData)}
                                            </span>
                                            :
                                            "Please configure a condition"
                                        }
                                    </Grid>
                                    <Grid item>
                                        <ModeEditIcon sx={{ display: "flex", height: "16px", width: "16px", cursor: "pointer" }} onClick={() => { setVariableConditionPopup(true); setTempNodesTemplate(nodes) }} />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                {variableConditionPopup &&
                    <GlobalPopUp
                        open={variableConditionPopup}
                        onClose={() => {
                            setVariableConditionPopup(false);
                        }}
                        flagBackdrop
                        paperMinWidth={flagSmallScreen ? "280px" : "850px"}
                        paperMaxwidth={flagSmallScreen ? "580px" : "850px"}
                        flagShowCloseIcon={true}
                        // height={"100%"}
                        titlePadding='0'
                        handleClose={() => {
                            setVariableConditionPopup(false)
                        }}
                    >
                        <CustomVarConditionPopup actionData={actionData} stepAction={stepAction} setVariableConditionPopup={setVariableConditionPopup} />
                    </GlobalPopUp>
                }
            </Grid>
        </>
    )
}

export default CustomVariableCondition
